var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 17L17 1","stroke":"#FF5001","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M16.7003 10.3894L16.6504 10.2128C15.8158 7.25272 15.869 4.11714 16.8035 1.19655V1.19655V1.19655C13.903 2.18555 10.7614 2.2432 7.81658 1.36148L7.61066 1.29983","stroke":"#FF5001","strokeWidth":"2","key":1})]);
}

Arrow.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
